import script from "./intro.vue?vue&type=script&setup=true&lang=js"
export * from "./intro.vue?vue&type=script&setup=true&lang=js"

import "./intro.vue?vue&type=style&index=0&id=e3973012&scoped=true&lang=css"

import exportComponent from "/Users/huangzexu/Code/Vue/Yiban/yiban/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3973012"]])

export default __exports__